import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import ArrivedIncomplete from '../../../forms/arrivedIncomplete/ArrivedIncomplete';
import MotiveTitle from '../MotiveTitle';
import ProductColorIcon from '../../../../../../../common/icons/icr_preparando_pedido.svg';

const ArrivedIncompleteMobile = ({ ...props }) => {
  const { motiveId, product, profile, type, onData } = props;
  return (
    <Box>
      <MotiveTitle
        icon={ProductColorIcon}
        title="Producto"
        subtitle="Llegó incompleto"
        mobile
      />
      <ArrivedIncomplete
        mobile
        motiveId={motiveId}
        product={product}
        profile={profile}
        type={type}
        onData={onData}
      />
    </Box>
  );
};

ArrivedIncompleteMobile.propTypes = {
  motiveId: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  type: PropTypes.string,
  onData: PropTypes.func,
};

export default ArrivedIncompleteMobile;
